<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12">
      <div class="alert alert-info text-center"><i aria-hidden="true" class="fa fa-info-circle"></i> {{ msg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoDataAvailable',
  props: {
    msg: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
